import PropTypes from 'prop-types'

/* types */
import { propTypesUser } from '../../currentUser/types'

export const propTypes = {
  comment: PropTypes.string.isRequired,
  commentable: PropTypes.object.isRequired,
  date: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  rating: PropTypes.number.isRequired,
  user: PropTypes.shape(propTypesUser).isRequired,
}
